import { Controller } from "@hotwired/stimulus"

// Subtle vertical parallax for a single decorative element (.hero-glow).
// Translates it in the OPPOSITE direction of scroll, clamped to a tiny
// range, so it drifts as you scroll the hero but never leaves the frame.
//
// Usage:
//   <section data-controller="scroll-parallax">
//     <div class="hero-glow"></div>
//     ...
//   </section>
//
// data-scroll-parallax-max-value (optional, px) caps the translate range.
export default class extends Controller {
  static values = { max: { type: Number, default: 28 } }

  connect() {
    if (this.prefersReducedMotion) return
    this.onScroll = this.onScroll.bind(this)
    this.ticking = false
    window.addEventListener("scroll", this.scheduleUpdate.bind(this), { passive: true })
    this.onScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this.scheduleUpdate)
  }

  scheduleUpdate() {
    if (this.ticking) return
    this.ticking = true
    window.requestAnimationFrame(() => {
      this.onScroll()
      this.ticking = false
    })
  }

  onScroll() {
    const rect = this.element.getBoundingClientRect()
    // Progress: 0 when section top is at viewport top; ~1 when it's scrolled
    // past by one section-height.
    const progress = Math.max(0, Math.min(1, -rect.top / Math.max(rect.height, 1)))
    const y = progress * this.maxValue
    this.element.style.setProperty("--parallax-y", `${y}px`)
  }

  get prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches
  }
}
